// General
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
// Redux
import { connect } from 'react-redux';
// Components
import RegisterForm from '../RegisterForm';
// Translation
import { closeSignupModal } from '../../actions/modalActions';

import cs from '../../components/commonStyle.css';
import s from './SignupModal.css';

const SignupModal = ({ signupModal, closeSignupModal }) => {
  const [signupModalStatus, setSignupModalStatus] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => {
    setIsFormOpen(true);
  };

  useEffect(() => {
    if (signupModal === true) {
      setSignupModalStatus(true);
    }
  }, []);

  useEffect(() => {
    setSignupModalStatus(signupModal);
  }, [signupModal]);

  return (
    <Modal
      show={signupModalStatus}
      animation={false}
      onHide={closeSignupModal}
      dialogClassName={cx('commonModalContainer', s.signUpModalContainer)}
    >
      <Modal.Header closeButton className='commonModalHeaderLess' />
      <Modal.Body bsClass='commonModalBody'>
        <RegisterForm />
      </Modal.Body>
    </Modal>
  );
};

SignupModal.propTypes = {
  closeSignupModal: PropTypes.func,
  signupModal: PropTypes.bool,
  formatMessage: PropTypes.func,
};

const mapState = state => ({
  signupModal: state.modalStatus.isSignupModalOpen,
});

const mapDispatch = {
  closeSignupModal,
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(SignupModal)));
